import {VideoPlayer} from "@/components/layouts/page/VideoPlayer";
import {Apart} from "@/pages/common/Home/Overview/Apart";
import {Benefits} from "@/pages/common/Home/Overview/Benefits";
import {Intro} from "@/pages/common/Home/Overview/Intro";

import repBlob from "@images/home/blue-blob.png";
import videoBtn from "@images/home/overview/video-btn.png";
import videoImage from "@images/home/overview/video-image.png";
import trainersBlob from "@images/home/peach-blob.png";
import {Logo} from "@ui/general/Logo";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

// import videoStreamEn from '@/assets/first_steps_overview_en.mp4'
// import videoStreamRu from '@/assets/first_steps_overview_ru.mp4'
import styles from "./styles.module.scss";

export const Overview = () => {
  const videoStreamEn = "/video/first_steps_overview_en.mp4";
  const videoStreamRu = "/video/first_steps_overview_ru.mp4";

  const {t} = useTranslation();
  const {language} = useSelector((state) => state.common.settings);

  const managers = [
    {
      id: 0,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.desc_1"),
          }}
        />
      ),
      icon: null,
    },
    {
      id: 1,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.desc_2"),
          }}
        />
      ),
      icon: "consistency",
    },
    {
      id: 2,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.desc_3"),
          }}
        />
      ),
      icon: "flexibility",
    },
    {
      id: 3,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.desc_4"),
          }}
        />
      ),
      icon: "progress",
    },
    {
      id: 4,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.title_5"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.desc_5"),
          }}
        />
      ),
      icon: "sales_data",
    },
    {
      id: 5,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.title_6"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.managers.desc_6"),
          }}
        />
      ),
      icon: "targeted",
    },
  ];

  const trainers = [
    {
      id: 0,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.desc_1"),
          }}
        />
      ),
      icon: "balanced",
    },
    {
      id: 1,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.desc_2"),
          }}
        />
      ),
      icon: null,
    },
    {
      id: 2,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.desc_3"),
          }}
        />
      ),
      icon: "data_driven",
    },
    {
      id: 3,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.desc_4"),
          }}
        />
      ),
      icon: "continuous",
    },
    {
      id: 4,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.title_5"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.desc_5"),
          }}
        />
      ),
      icon: "scalable",
    },
    {
      id: 5,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.title_6"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.trainers.desc_6"),
          }}
        />
      ),
      icon: "reduce_time",
    },
  ];

  const representatives = [
    {
      id: 0,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.desc_1"),
          }}
        />
      ),
      icon: "access",
    },
    {
      id: 1,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.desc_2"),
          }}
        />
      ),
      icon: "practice",
    },
    {
      id: 2,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.desc_3"),
          }}
        />
      ),
      icon: null,
    },
    {
      id: 3,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.desc_4"),
          }}
        />
      ),
      icon: "customisable",
    },
    {
      id: 4,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.title_5"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.desc_5"),
          }}
        />
      ),
      icon: "hcp",
    },
    {
      id: 5,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.title_6"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.reps.desc_6"),
          }}
        />
      ),
      icon: "feedback",
    },
  ];

  const video = {
    preview: (
      <div className={styles.video_preview}>
        <div className={styles.video_left}>
          <h2>
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.overview.video_title"),
              }}
            />
          </h2>

          <Logo direction={"footer"} />
        </div>

        <div className={styles.video_right}>
          <i />
          <img
            src={videoImage}
            alt={"video-image"}
          />
        </div>
      </div>
    ),
    videoStream: language === "en" ? videoStreamEn : videoStreamRu,
  };

  return (
    <>
      <Helmet title={t("head_title.overview")} />

      <div className={"container-big"}>
        <div className={styles.overview_page}>
          <Intro />

          <div className={"container-home"}>
            <Benefits
              items={managers}
              itemChild={0}
              itemBackColor={
                "linear-gradient(109deg, rgba(87, 57, 150, 0.50) 0%, rgba(245, 129, 213, 0.50) 100%), rgba(255, 255, 255, 0.20)"
              }
              itemHover={"linear-gradient(135deg, #8692CB 0%, #B262C9 100%)"}
            />
          </div>

          <div className={"container-home"}>
            <Benefits
              items={trainers}
              itemChild={1}
              itemBackColor={
                "linear-gradient(90deg, rgba(255, 154, 158, 0.80) 0%, rgba(250, 208, 196, 0.80) 99%, rgba(250, 208, 196, 0.80) 100%), rgba(255, 255, 255, 0.20)"
              }
              itemHover={"linear-gradient(90deg, #FFD293 0%, #FB9675 100%)"}
            />

            <img
              className={styles.trainers_blob}
              src={trainersBlob}
              alt={"blob"}
            />
          </div>

          <div className={"container-home"}>
            <Benefits
              items={representatives}
              itemChild={2}
              itemBackColor={
                "linear-gradient(90deg, #A6C0FE 0%, #F68084 100%), rgba(255, 255, 255, 0.20)"
              }
              itemHover={"linear-gradient(90deg, #FBC2EB 0%, #A6C1EE 100%)"}
            />

            <img
              className={styles.representatives_blob}
              src={repBlob}
              alt={"blob"}
            />
          </div>

          <div className={styles.video_wrapper}>
            <VideoPlayer
              playBtnImg={videoBtn}
              playBtnSize={180}
              video={video}
              controlBar={false}
            />
          </div>

          <div className={"container-home"}>
            <Apart />
          </div>
        </div>
      </div>
    </>
  );
};
